import {
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap";
import { useState } from "react";
import { useSetRewardPerReferral } from "lib/api-referral";

const ReferralSettings = ({ showAlert, onRefresh }) => {
    const { mutate: setRewardPerReferralMutation, isLoading } =
        useSetRewardPerReferral();
    const [rewardAmount, setRewardAmount] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!rewardAmount || rewardAmount === "") {
            showAlert("Please enter a valid reward amount", "danger");
            return;
        }

        const amount = parseFloat(rewardAmount);
        if (isNaN(amount) || amount < 0) {
            showAlert("Please enter a valid positive number", "danger");
            return;
        }

        setRewardPerReferralMutation(
            { rewardPerReferral: amount },
            {
                onSuccess: () => {
                    showAlert(
                        `Referral reward updated to $${amount.toFixed(2)}`,
                        "success"
                    );
                    setIsEditing(false);
                    setRewardAmount("");
                    setTimeout(() => {
                        onRefresh();
                    }, 1000);
                },
                onError: (error) => {
                    showAlert(
                        `Failed to update referral reward: ${error.message}`,
                        "danger"
                    );
                },
            }
        );
    };

    const handleCancel = () => {
        setIsEditing(false);
        setRewardAmount("");
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    return (
        <Container className="mt-4" fluid>
            <Row>
                <Col xl="6" lg="8" md="10">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <Row className="align-items-center">
                                <Col xs="8">
                                    <h3 className="mb-0">
                                        Referral Reward Settings
                                    </h3>
                                    <p className="text-sm text-muted mb-0">
                                        Configure the global reward amount per
                                        successful referral
                                    </p>
                                </Col>
                                <Col xs="4" className="text-right">
                                    {!isEditing && (
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={handleEdit}
                                        >
                                            <i className="fas fa-edit" /> Edit
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </CardHeader>

                        <CardBody>
                            {isEditing ? (
                                <Form onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <Label for="rewardAmount">
                                            Reward Amount per Referral
                                        </Label>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    $
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                type="number"
                                                id="rewardAmount"
                                                placeholder="Enter reward amount"
                                                value={rewardAmount}
                                                onChange={(e) =>
                                                    setRewardAmount(
                                                        e.target.value
                                                    )
                                                }
                                                min="0"
                                                step="0.01"
                                                required
                                                disabled={isLoading}
                                            />
                                        </InputGroup>
                                        <small className="form-text text-muted">
                                            This amount will be credited to
                                            users for each successful referral
                                        </small>
                                    </FormGroup>

                                    <div className="d-flex justify-content-end">
                                        <Button
                                            color="secondary"
                                            size="sm"
                                            onClick={handleCancel}
                                            disabled={isLoading}
                                            className="mr-2"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin" />{" "}
                                                    Updating...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-save" />{" "}
                                                    Update Reward
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                            ) : (
                                <div className="text-center py-4">
                                    <div
                                        className="icon icon-shape bg-primary text-white rounded-circle shadow mx-auto mb-3"
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            lineHeight: "60px",
                                        }}
                                    >
                                        <i className="fas fa-gift" />
                                    </div>
                                    <h4 className="text-muted">
                                        Referral Reward Configuration
                                    </h4>
                                    <p className="text-sm text-muted">
                                        Click the "Edit" button above to set or
                                        update the reward amount that users
                                        receive for each successful referral.
                                    </p>
                                    <div className="mt-3">
                                        <small className="text-muted">
                                            <i className="fas fa-info-circle" />{" "}
                                            This setting applies globally to all
                                            users
                                        </small>
                                    </div>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>

                <Col xl="6" lg="8" md="10">
                    {/* <Card className="shadow">
                        <CardHeader className="border-0">
                            <h3 className="mb-0">Quick Stats</h3>
                        </CardHeader>
                        <CardBody>
                            <div className="text-center">
                                <div className="icon icon-shape bg-success text-white rounded-circle shadow mx-auto mb-3" style={{ width: '50px', height: '50px', lineHeight: '50px' }}>
                                    <i className="fas fa-chart-line" />
                                </div>
                                <h5 className="text-muted mb-3">Referral Program Status</h5>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="text-center border-right">
                                            <span className="h4 font-weight-bold text-success">Active</span>
                                            <p className="text-sm text-muted mb-0">Status</p>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="text-center">
                                            <span className="h4 font-weight-bold text-primary">Global</span>
                                            <p className="text-sm text-muted mb-0">Scope</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card> */}

                    <Card className="shadow mt-4">
                        <CardHeader className="border-0">
                            <h3 className="mb-0">Instructions</h3>
                        </CardHeader>
                        <CardBody>
                            <div className="text-sm">
                                <div className="mb-3">
                                    <i className="fas fa-check text-success mr-2" />
                                    Set individual user referral limits in the
                                    table below
                                </div>
                                <div className="mb-3">
                                    <i className="fas fa-check text-success mr-2" />
                                    Configure global reward amount for all
                                    referrals
                                </div>
                                <div className="mb-3">
                                    <i className="fas fa-check text-success mr-2" />
                                    Monitor user referral performance and status
                                </div>
                                <div className="mb-3">
                                    <i className="fas fa-check text-success mr-2" />
                                    Search and filter users by email or username
                                </div>
                                <div className="mb-0">
                                    <i className="fas fa-check text-success mr-2" />
                                    Refferal Limit for Individual User cannot be more than 10.
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ReferralSettings;
